export default __webpack_public_path__ + "static/media/moreicon.cc01122d.svg";